/* unplugin-vue-components disabled */import script from "./PageScrollRope.vue?vue&type=script&setup=true&lang=js"
export * from "./PageScrollRope.vue?vue&type=script&setup=true&lang=js"

import "./PageScrollRope.vue?vue&type=style&index=0&id=be86caa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be86caa8"]])

export default __exports__